// Contextul paginii vizionate, transmis asistentului AI când utilizatorul
// întreabă de pe pagina unui anunț sau a unui dealer.
// Setat de CarDetailV3 / DealerPublicPage / DealerPublicListings, citit de AIAssistant.
export interface AssistantListingContext {
  id: string;
  title: string;
  year?: number | null;
  price?: number | null;
  currency?: string | null;
  mileage?: number | null;
  fuel?: string | null;
  transmission?: string | null;
  location?: string | null;
  sellerType?: string | null;
  description?: string | null;
}

export interface AssistantDealerContext {
  id: string;
  name: string;
  city?: string | null;
  address?: string | null;
  phone?: string | null;
  email?: string | null;
  website?: string | null;
  openingHours?: string | null;
  yearsInBusiness?: number | null;
  verified?: boolean | null;
  rating?: number | null;
  reviewCount?: number | null;
  description?: string | null;
  activeListings?: number | null;
  makes?: string | null;
}

let currentListing: AssistantListingContext | null = null;
let currentDealer: AssistantDealerContext | null = null;

export function setAssistantListingContext(ctx: AssistantListingContext | null) {
  currentListing = ctx;
}

export function getAssistantListingContext(): AssistantListingContext | null {
  return currentListing;
}

export function setAssistantDealerContext(ctx: AssistantDealerContext | null) {
  currentDealer = ctx;
}

export function getAssistantDealerContext(): AssistantDealerContext | null {
  return currentDealer;
}
